module.exports = __webpack_public_path__ + "img/动态礼物--3d效果gif.a62957e3.gif";